import {
  CircularProgress as MUICircularProgress,
  CircularProgressProps as MUICircularProgressProps,
} from '@mui/material';
import { memo } from 'react';
import { B1 } from '../../theme';
import { mergeSX } from '../../services/helpers';

interface IBuildSXParams {
  color: string;
}

const buildSX = ({ color }: IBuildSXParams) => ({
  '& svg': {
    color,
  },
});

export interface ICircularProgressProps extends Omit<MUICircularProgressProps, 'color'> {
  color?: string
}

const CircularProgress = (props: ICircularProgressProps) => {
  const { color = B1, sx, ...restProps } = props;
  return (
    <MUICircularProgress sx={mergeSX(buildSX({ color }), sx)} {...restProps} />
  );
};

export default memo(CircularProgress);
